import { fetchData } from "utils/api";

const accessBoardService = {
  getAccessList: async () =>
    fetchData(
      `${process.env.REACT_APP_BASE_URL}/user/all_user/`,
      "GET",
      null,
      true
    ),
  grantAccess: async (accessData) =>
    fetchData(
      `${process.env.REACT_APP_BASE_URL}/user/${accessData?.userPhoneNumber}/grant_access/`,
      "POST",
      { grant_access: accessData.hasAccess }
    ),
};

export default accessBoardService;
